import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const bordered = (theme) => ({
  border: `1px solid ${theme.onCardDivider.green_75}`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4)
});

export default makeStyles((theme) => ({
  priceDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  heading: {
    margin: 0,
    fontWeight: 400,
    lineHeight: '24px',
    color: theme.onCard.white
  },
  box: {
    ...bordered(theme),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  divider: {
    margin: 0,
    '&::before, &::after': {
      backgroundColor: theme.onCardDivider.green_75,
      opacity: 0.5
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4)
  },
  rowLabel: {
    flex: 1,
    lineHeight: '20px',
    color: theme.colorPalette.beige_60,
    ...reskinStyles(theme, { color: theme.colors.text_secondary })
  },
  amount: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    whiteSpace: 'nowrap'
  },
  currency: {
    lineHeight: '20px',
    color: theme.onCard.white
  },
  amountValue: {
    fontSize: 24,
    lineHeight: '32px',
    color: theme.onCard.white
  },
  payments: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  multiply: {
    width: 16,
    height: 16
  },
  paymentScheduleLink: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  termTotal: {
    ...bordered(theme),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4)
  },
  termTotalValue: {
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    color: theme.onCard.beige_25
  }
}));
